import React, {Component} from 'react';
import SignUpSuccess from './SignUpSuccess/SignUpSuccess';

const LoginToken = withLoginToken(
  SignUpSuccess,
  (props) => props.getLoginToken()
)

function withLoginToken(WrappedComponent, selectData) {
  return class extends Component {
    constructor(props) {
      super(props);
      this.state = {
        timer : null
      }
    }
    componentDidMount() {
      this.props.getLoginToken();
      let timerId = setInterval(() => this.props.renewLoginToken(this.props.loginToken), 120000);
      this.setState({timer: timerId});
    }

    componentWillUnmount() {
      clearInterval(this.state.timer);
    }

    render() {
      return <SignUpSuccess {...this.props} />
    }
  }
}

export default LoginToken;



// WEBPACK FOOTER //
// ./src/components/SignUpSuccessContainer/LoginToken.js